/* Progressive enhancement only. Native Horizon forms remain untouched. */
(() => {
  if (window.vrStoreInitialized) return;
  window.vrStoreInitialized = true;
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.matches('[data-vr-track]')) {
      event.preventDefault();
      const number = form.elements.nums.value.trim();
      if (!number) return;
      window.open('https://t.17track.net/en#nums=' + encodeURIComponent(number), '_blank', 'noopener,noreferrer');
    }
    if (!form.matches('[data-vr-addon]') || !window.fetch) return;
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    if (button.disabled) return;
    button.disabled = true;
    const status = form.querySelector('[data-vr-addon-status]');
    status.textContent = 'Adding…';
    try {
      const response = await fetch(form.action.replace(/\/?$/, '.js'), {method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || 'This option could not be added. Please try again.');
      // A normal cart navigation ensures cart totals and the native drawer state cannot go stale.
      window.location.assign((window.Shopify?.routes?.root || '/') + 'cart');
    } catch (error) { status.textContent = error.message || 'Unable to add this item. Please try again.'; button.disabled = false; }
  });
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-vr-consent]');
    if (!button) return;
    const box = button.closest('[data-vr-privacy]');
    const status = box.querySelector('[data-vr-consent-status]');
    const fallback = () => {status.textContent = 'The privacy controls are unavailable right now. Please use the store cookie banner or email us with your request.';button.disabled=false;};
    button.disabled=true;
    status.textContent='Saving your choice…';
    const save = () => {
      if (!window.Shopify?.customerPrivacy) return fallback();
      const choice = button.dataset.vrConsent === 'optout' ? {sale_of_data:false} : {analytics:false,marketing:false,preferences:false};
      try {window.Shopify.customerPrivacy.setTrackingConsent(choice, () => {status.textContent='Your choice has been saved for this browser. For requests relating to your account or previous orders, please email us.';button.disabled=false;});} catch {fallback();}
    };
    if (window.Shopify?.customerPrivacy) save();
    else if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>error?fallback():save());
    else fallback();
  });
})();
